import Link from 'next/link';
import React, { useEffect, useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'

const FAQ_mobile = ({ FaqTableData, heading }) => {
   const [viewAll, setViewAll] = useState(true);
   const [showAns, setShowAns] = useState({ key: "", status: false });
   const [showAtRender, setShowAtRender] = useState(true);

   useEffect(() => {
      const timer = setTimeout(() => {
         setShowAtRender(false);
      }, 10);

      return () => clearTimeout(timer);
   }, []);

   const handleScroll = (e) => {
      e.preventDefault();
      const href = e.currentTarget.href;
      const targetId = href.replace(/.*\#/, "");
      const elem = document.getElementById(targetId);
      elem?.scrollIntoView({
         behavior: "smooth",
      });
   };

   useEffect(() => {
      window.addEventListener("scroll", () => {
         window.scrollY > 200 && window.scrollY < 500 && setViewAll(false);
      });
   }, []);


   const initialFAQsCount = 5;
   const displayedFAQs = viewAll ? FaqTableData : FaqTableData.slice(0, initialFAQsCount);

   return (
      <div style={{ margin: "4rem 2rem", display: "flex", flexDirection: "column", alignItems: "center" }} id="faq-section">
         <div style={{ width: "fit-content", margin: "auto" }}><h3 style={{ font: "normal normal bold 2.2rem/3rem Inter" }}>{heading}</h3></div>
         <div style={{ width: "100%" }}>
            {
               displayedFAQs?.map((ele, idx) => {
                  return (
                     <div key={ele?.id}>

                        <div style={{ padding: "2rem 1rem 1rem 1rem", borderBottom: "1px solid #ececec", backgroundColor: "white" }}>
                           <div style={{ display: "flex", justifyContent: "space-between", gap: "5rem", cursor: "pointer", color: "#101828", font: "normal normal 500 1.8rem/2.2rem" }} onClick={() => setShowAns({ key: ele?.id, status: showAns?.key === ele?.id ? !showAns?.status : true })}>
                              <p style={{ color: "#626060", marginBottom: "0", font: "normal normal 500 1.6rem/2.4rem Inter" }}>{ele?.para}</p>
                              <span style={{ color: "#2a6ab4", fontSize: "1.8rem", }}><IoIosArrowDown /></span>
                           </div>
                           <p
                              style={
                                 // { color: "#475467", , font: "normal normal normal 1.6rem/2rem Inter" }
                                 showAns?.key === ele?.id && showAns?.status ? {
                                    color: "#475467", maxHeight: "40rem", transition: "all 0.3s", paddingTop: "1rem", marginRight: "3rem"
                                 } : {
                                    color: "#475467", maxHeight: "0rem", transition: "all 0.3s", marginRight: "3rem", display: "none"
                                 }
                              }
                           >
                              {
                                 ((showAns?.key === ele?.id && showAns?.status) || showAtRender) ? ele?.des : ""
                              }
                           </p>
                        </div>
                     </div>
                  )
               })
            }
         </div>
         <Link href='#faq-section' onClick={(e) => handleScroll(e)} style={{ textDecoration: "none" }}><p style={{ color: "#2a6ab4", cursor: "pointer", marginTop: "3rem", font: "normal normal 500 1.6rem/2rem Inter" }} onClick={() => setViewAll(!viewAll)}>{viewAll ? 'View Less' : 'View All'}</p></Link>
      </div>
   )
}

export default FAQ_mobile